/** @format */

import {
    COLOR_4C,
    COLOR_5C,
    COLOR_CAPATIBILITY_MATRIX,
    COLOR_DOUBLE_SIDED,
    LAMINATE_GLOSS_FINISH,
    LAMINATE_NO_LAMINATE,
    NO_LAMINATE_SUBSTRATES,
    SUBSTRATE_DEFAULT_HIGH_OPACITY_WHITE
} from 'frontier-constants';

/**
 * Changing the substrate requires setting laminate and color to specific values depending on compatibilty
 * @param laminateId
 * @param currentColorId
 * @param substrateId
 * @returns {{color_id: {$set: number}, substrate_id: {$set}}}
 */
export default ({laminateId, colorId: currentColorId, substrateId}) => {
    let colorId = currentColorId;
    if (COLOR_CAPATIBILITY_MATRIX[currentColorId].indexOf(substrateId) === -1) {
        // Changing to an incompatible color
        if (COLOR_CAPATIBILITY_MATRIX[COLOR_5C].indexOf(substrateId) > -1) {
            colorId = COLOR_5C;
        } else if (COLOR_CAPATIBILITY_MATRIX[COLOR_4C].indexOf(substrateId) > -1) {
            colorId = COLOR_4C;
        } else if (COLOR_CAPATIBILITY_MATRIX[COLOR_DOUBLE_SIDED].indexOf(substrateId) > -1) {
            colorId = COLOR_DOUBLE_SIDED;
        }
    }

    const updateTarget = {
        color_id: {$set: colorId},
        substrate_id: {$set: substrateId}
    };

    if (NO_LAMINATE_SUBSTRATES.indexOf(substrateId) > -1) {
        // we have a laminate set but we are moving to a no laminate situation.
        updateTarget.laminate_id = {$set: LAMINATE_NO_LAMINATE}; // NO LAMINATE
    } else if (
        laminateId === LAMINATE_NO_LAMINATE &&
        NO_LAMINATE_SUBSTRATES.indexOf(substrateId) === -1
    ) {
        // Moving from a no laminate to a laminate required....
        updateTarget.laminate_id = {$set: LAMINATE_GLOSS_FINISH};
    }

    if (SUBSTRATE_DEFAULT_HIGH_OPACITY_WHITE.indexOf(substrateId) > -1) {
        updateTarget.is_high_opacity_white = {$set: true};
    } else {
        updateTarget.is_high_opacity_white = {$set: false};
    }

    return updateTarget;
};
